export const skeletonProps = { speed: 2 };
